import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from '../../src/i18n';
import { TP } from '../../constants/consts';
import Button from '../Button';
import LastUpdate from '../LastUpdate';

const useStyles = makeStyles(() => ({
  footer: {
    marginTop: '30px',
    display: 'flex',
  },
  submitButton: {
    marginRight: '20px',
  },
}));

const EditFormFooter = ({ submitFunc, lastUpdatedDate, isLoading, buttonTitle }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.footer}>
      <Button variant="outlined" className={classes.submitButton} onClick={submitFunc} isLoading={isLoading}>
        {t(buttonTitle)}
      </Button>
      {lastUpdatedDate && <LastUpdate date={lastUpdatedDate} />}
    </div>
  );
};

EditFormFooter.propTypes = {
  submitFunc: PropTypes.func.isRequired,
  lastUpdatedDate: PropTypes.string,
  isLoading: PropTypes.bool,
  buttonTitle: PropTypes.string,
};

EditFormFooter.defaultProps = {
  lastUpdatedDate: '',
  isLoading: false,
  buttonTitle: `${TP}.FN_SAVE_CONTINUE_BUTTON`,
};

export default memo(EditFormFooter);
